import { AccountBalancesStatsParam } from '@tassat/fred-extended-definitions';

import { Withdrawal } from './withdrawal';
import { IWithdrawalFormValues } from './withdrawalForm/types';

export interface IWithdrawalProps {
    title: string;
    transactionValues: IWithdrawalFormValues;
    setTransactionValues: (values?) => void;
    handleWithdrawal: (handleWithdrawal) => void;
    goBack: (event?) => void;
    accountPositionBalance: AccountBalancesStatsParam;
}

export default Withdrawal;